export default __webpack_public_path__ + "static/screeny-130-gpz-i-3-56bcd6489959903b8080e126c9daefdd.jpg";